import React, { Component } from "react"
import AxiosConfig from "../../../../utilities/AxiosConfig";
import axios from "axios";
import moment from "moment";
import "./VehicleAttachments.css"
import { Button, FormControl, Modal, OverlayTrigger, Table, Tooltip } from "react-bootstrap";
import IconBuilder from "../../../../utilities/iconBuilder/IconBuilder";

interface AttachmentsProps {
    details: any
    userId: any
    refreshAll: Function
    attachments: Array<any>
}

type AttachmentsTypes = {
    preview: boolean
    openAttachment: any
    commentInput: string
    noteInput: string
    eventType: string
    confirmDelete: boolean
}

class VehicleAttachments extends Component<AttachmentsProps, AttachmentsTypes> {

    constructor(props: AttachmentsProps) {
        super(props)
        this.state = {
            preview: false,
            openAttachment: {},
            commentInput: "",
            noteInput: "",
            eventType: "comment",
            confirmDelete: false
        }
    }

    fileSelectedHandler = (event: any) => {
        if (event.target.files && event.target.files[0]) {
            let file = event.target.files[0];
            let infoId = parseInt(this.props.details.VehicleInformationId);
            let date = Date.now()
            let regex = /(?:\.([^.]+))?$/;
            //@ts-ignore
            let extension = regex.exec(file.name)[1]
            let path = `${infoId}_${file.name}`
            path = path.replace(/\.[^/.]+$/, "")
            path = `${path}_${date}.${extension}`
            this.fileUploadHandler(file, path)
        }
    }

    fileUploadHandler = (file: any, path: string,) => {
        let fd = new FormData()
        fd.append('File', file, file.name)
        fd.append("Json",
            JSON.stringify({
                RelativePathAndName: path,
                storageLocation: process.env.REACT_APP_VEHICLE_ATTACHMENTS_API_URL
            })
        )
        axios.post(process.env.REACT_APP_IMG_API_URL + "/api/file", fd, AxiosConfig.configValue("min"))
            .then(res => {
                this.fileAttachToHandler(file, path)
            }).catch(err => {
                //console.log(err)
                //handle error
            })
    }

    fileAttachToHandler = (file: any, path: string) => {
        let requestBody =
        {
            VehicleAttachmentId: "",
            VehicleInformationId: parseInt(this.props.details.VehicleInformationId),
            AttachmentContent: null,
            ContentType: "image/jpeg",
            ContentLength: "11045",
            AttachmentType: "JPG",
            Comment: null,
            CopropateNote: null,
            DocumentName: file.name,
            Path: process.env.REACT_APP_VEHICLE_ATTACHMENTS_API_URL,
            NewDocumentName: path,
            CreatedDate: moment().format(),
            CreatedBy: parseInt(this.props.userId),
            ModifyDate: moment().format(),
            ModifiedBy: parseInt(this.props.userId),
            DeletedDate: null,
            DeletedBy: null,
            DisabledDate: null,
            DisabledBy: null,
            ImageFileStoreLocationID: process.env.REACT_APP_VEHICLE_ATTACHMENTS_STORE_LOCATION
        }

        // //console.log(process.env)

        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateVehicleAttachment", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                this.props.refreshAll("attachments")
            }).catch(err => {
                //console.log(err)
                //handle error
            })
    }

    previewAttachment = (attachment?: any) => {
        if (this.state.preview) {
            this.setState({ preview: false, noteInput: "", commentInput: "" })
        } else {
            this.setState({ preview: true, openAttachment: attachment })
        }
    }

    toggleDeleteConfirm = () => {
        if (this.state.confirmDelete) {
            this.setState({ confirmDelete: false })
        } else {
            this.setState({ confirmDelete: true })
        }
    }

    updateAttachment = (deleteDate?: number) => {

        let CorporateNote = ""
        let Comment = ""

        if (this.state.noteInput !== "") {
            CorporateNote = this.state.noteInput
        } else {
            CorporateNote = this.state.openAttachment.CorporateNote
        }

        if (this.state.commentInput !== "") {
            Comment = this.state.commentInput
        } else {
            Comment = this.state.openAttachment.Comment
        }

        let requestBody: any =
        {
            VehicleAttachmentId: this.state.openAttachment.VehicleAttachmentId,
            VehicleInformationId: parseInt(this.props.details.VehicleInformationId),
            AttachmentContent: null,
            ContentType: "image/jpeg",
            ContentLength: "11045",
            AttachmentType: "JPG",
            Comment: Comment,
            CorporateNote: CorporateNote,
            DocumentName: this.state.openAttachment.DocumentName,
            Path: process.env.REACT_APP_VEHICLE_ATTACHMENTS_API_URL,
            NewDocumentName: this.state.openAttachment.NewDocumentName,
            CreatedDate: this.state.openAttachment.CreatedDate,
            CreatedBy: parseInt(this.state.openAttachment.CreatedBy),
            ModifyDate: moment().format(),
            ModifiedBy: parseInt(this.props.userId),
            DeletedDate: null,
            DeletedBy: null,
            DisabledDate: null,
            DisabledBy: null
        }

        if (deleteDate) {
            requestBody.DeletedDate = moment(deleteDate).format()
            requestBody.DeletedBy = parseInt(this.props.userId)
        }

        axios.post(process.env.REACT_APP_API_URL + "/api/Fleet/CreateOrUpdateVehicleAttachment", requestBody, AxiosConfig.configValue("min"))
            .then(res => {
                if (!deleteDate) {
                    this.props.refreshAll("attachments")
                    this.previewAttachment()
                } else {
                    this.props.refreshAll("attachments")
                    this.setState({
                        preview: false,
                        openAttachment: {},
                        commentInput: "",
                        noteInput: "",
                        eventType: "comment",
                        confirmDelete: false
                    })
                }
            }).catch(err => {
                //console.log(err)
                //handle error
            })
    }

    changeEventType = (type: string) => {
        if (type === "comment") {
            this.setState({ eventType: "comment" })
        }
        if (type === "note") {
            this.setState({ eventType: "note" })
        }
    }

    handleChange = (event: any) => {
        if (this.state.eventType === "comment") {
            this.setState({ commentInput: event.target.value })
        }
        if (this.state.eventType === "note") {
            this.setState({ noteInput: event.target.value })
        }
    }

    render() {

        let attachments = this.props.attachments

        if (attachments.length > 0) {
            for (let i = 0; i < attachments.length; i++) {
                attachments[i].extension = attachments[i].NewDocumentName.substring(attachments[i].NewDocumentName.lastIndexOf('.') + 1, attachments[i].NewDocumentName.length) || attachments[i].NewDocumentName;
            }
        }

        const downloadTooltip = (
            <Tooltip id="va-pin-tooltip">
                Download Attachment
            </Tooltip>
        )


        const deleteTooltip = (
            <Tooltip id="va-pin-tooltip">
                Delete Attachment
            </Tooltip>
        )

        const newAttachmentTooltip = (
            <Tooltip id="va-pin-tooltip">
                Add an Attachment
            </Tooltip>
        )

        return (
            <div className="VehicleAttachments">
                <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={newAttachmentTooltip}>
                    <div className="CustomFileUploadWrapper">
                        <label htmlFor="ChooseFile" className="custom-file-upload">
                            <span className="material-icons">file_upload</span>
                        </label>
                        <input id="ChooseFile" type="file" onChange={this.fileSelectedHandler} />
                    </div>
                </OverlayTrigger>
                {this.state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        <p id="fleet-attachment-confirm-delete-header">Delete this attachment?</p>
                    </Modal.Header>
                    <Modal.Footer>
                        <div className="FleetAttachmentsConfirmDeleteFooter">
                            <Button id="fleet-attachment-cancel-delete-btn" variant="secondary" onClick={this.toggleDeleteConfirm}>Cancel</Button>
                            <Button id="fleet-attachment-confirm-delete-btn" variant="danger" onClick={() => this.updateAttachment(Date.now())}>Delete</Button>
                        </div>
                    </Modal.Footer>
                </Modal>}
                {this.state.preview && !this.state.confirmDelete && <Modal
                    show={true}
                    backdrop="static"
                    keyboard={true}
                >
                    <Modal.Header>
                        <div className="FleetAttachmentPreviewHeader">
                            <IconBuilder extension={this.state.openAttachment.extension} size={64} />
                            <p>{this.state.openAttachment.DocumentName}</p>
                        </div>
                        <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={deleteTooltip}>
                            <p id="vehicle-attachments-delete-btn" onClick={this.toggleDeleteConfirm}><span className="material-icons">delete</span></p>
                        </OverlayTrigger>
                    </Modal.Header>
                    <Modal.Body>
                        <div id="fleet-attachment-modal-body-date">
                            <span className="material-icons">event</span>
                            <p>Created {this.state.openAttachment.CreatedDate.split("T")[0]} by {this.state.openAttachment.CreatedByName} </p>
                        </div>
                        <div id="fleet-attachment-modal-body-comments">
                            <p>Comments:</p>
                            <FormControl
                                as="textarea"
                                rows={4}
                                placeholder={this.state.openAttachment.Comment || "None"}
                                aria-describedby="basic-addon1"
                                onFocus={() => this.changeEventType("comment")}
                                onChange={this.handleChange}
                                value={this.state.commentInput}
                            />
                            <p>Corporate Notes:</p>
                            <FormControl
                                as="textarea"
                                rows={4}
                                placeholder={this.state.openAttachment.CorporateNote || "None"}
                                aria-describedby="basic-addon1"
                                onFocus={() => this.changeEventType("note")}
                                onChange={this.handleChange}
                                value={this.state.noteInput}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <div id="fleet-attachment-modal-body-download-btn">
                            <OverlayTrigger trigger={["hover", "focus"]} placement="auto-end" overlay={downloadTooltip}>
                                <a href={this.state.openAttachment.Path + this.state.openAttachment.NewDocumentName} target="_blank" rel="noreferrer"><span className="material-icons">file_download</span></a>
                            </OverlayTrigger>
                        </div>
                        {(this.state.commentInput !== "" || this.state.noteInput !== "") && <Button variant="primary" onClick={() => this.updateAttachment()}>Save Changes</Button>}
                        <Button variant="secondary" onClick={this.previewAttachment}>Close</Button>
                    </Modal.Footer>
                </Modal>}
                <div className="AttachmentsWrapper">
                    {attachments.length > 0 && <Table striped bordered hover>
                        <thead>
                            <tr>
                                <th>DocType</th>
                                <th>Document Name</th>
                                <th>Comments</th>
                                <th>Corporate Notes</th>
                                <th>Created</th>
                                <th>Created by</th>
                            </tr>
                        </thead>
                        <tbody>
                            {attachments.map((attachment: any, i: number) =>
                                <tr key={attachment.DocumentName + i} onClick={() => this.previewAttachment(attachment)}>
                                    <td >
                                        <div id="fleet-attachments-doc-type-wrapper">
                                            <IconBuilder extension={attachment.extension} size={32} />
                                            <p>{attachment.extension}</p>
                                        </div>
                                    </td>
                                    <td >{attachment.DocumentName}</td>
                                    <td >{attachment.Comment}</td>
                                    <td >{attachment.CorporateNote}</td>
                                    <td >{attachment.CreatedDate.split("T")[0]}</td>
                                    <td >{attachment.CreatedByName}</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>}
                </div>
            </div>
        )
    }
}

export default VehicleAttachments
